<template>
<div>
  <!-- template for the user modal component -->
  <transition name="modal">
    <div class="modal-backdrop" role="dialog">
      <div class="modal" ref="modal" aria-labelledby="modalTitle" aria-describedby="modalDescription" v-on-clickaway="away">
        <header class="modal-header" id="modalTitle">
          <slot name="header">
            {{modalHeading}}
            <button type="button" class="btn-close pull-right" @click="close" aria-label="Close modal"><i class="ti-close"></i></button>
          </slot>
        </header>
        <form @submit.prevent="addUpdateUser('userForm')" data-vv-scope="userForm">
          <section class="modal-body" id="userForm">
            <slot name="body">
              <div class="row">
                <div class="col-md-6 error_height">
                  <div class="form-group">
                    <label>First Name</label>
                    <input type="text" name="FNAME" v-model="FNAME" v-validate="'required|alpha_spaces'" :class="{'input form-control border-input': true, 'border-danger': errors.has('userForm.FNAME') }"></input>
                    <span v-show="errors.has('userForm.FNAME')" class="text-danger">{{ errors.first('userForm.FNAME') }}</span>
                  </div>
                </div>
                <div class="col-md-6 error_height">
                  <div class="form-group">
                    <label>Last Name</label>
                    <input type="text" name="LNAME" v-model="LNAME" v-validate="'required|alpha_spaces'" :class="{'input form-control border-input': true, 'border-danger': errors.has('userForm.LNAME') }"></input>
                    <span v-show="errors.has('userForm.LNAME')" class="text-danger">{{ errors.first('userForm.LNAME') }}</span>
                  </div>
                </div>
                <div class="col-md-6 error_height">
                  <div class="form-group">
                    <label>Email</label>
                    <input type="text" name="EMAIL" v-model="EMAIL" v-validate="'required|email'" :class="{'input form-control border-input': true, 'border-danger': errors.has('userForm.EMAIL') }"></input>
                    <span v-show="errors.has('userForm.EMAIL')" class="text-danger">{{ errors.first('userForm.EMAIL') }}</span>
                  </div>
                </div>
                <div class="col-md-6 error_height">
                  <div class="form-group">
                    <label>Phone</label>
                    <input type="text" name="PHONE" v-model="PHONE" class="input form-control border-input"></input>
                  </div>
                </div>
                <div v-if="support" class="col-md-6 error_height">
                  <label>New Password</label>
                    <input type="text" name="PASSWORD" v-model="PASSWORD" class="input form-control border-input"></input>
                </div>
                <div v-if="support" class="col-md-6 error_height">
                  <label>Company</label>
                  <multiselect
                    v-model="np_selected"
                    :options="nationalPartners"
                    :multiple="true"
                    pen-direction="bottom"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Choose National Partner(s)"
                    label="NAME"
                    track-by="CODE"
                    select-label="Click to select"
                    deselect-label="Click to remove"
                    :preselect-first="false"
                    :taggable="true"
                    @close="getRestaurants()">
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="np_selected.length" @mousedown.prevent.stop="clearAllNP()">❌</div>
                    </template>
                  </multiselect>
                  <span v-show="errors.has('userForm.COMPANY')" class="text-danger">{{ errors.first('userForm.COMPANY') }}</span>
                </div>
                <div v-if="support" class="col-md-6 error_height">
                  <label>User Type</label>
                  <select class="form-control input-group" v-validate="'required'" name="ROLE" v-model="ROLE">
                    <option v-for="user in userRoles" v-bind:value="user.value">
                      {{ user.name }}
                    </option>
                  </select>
                  <span v-show="errors.has('userForm.ROLE')" class="text-danger">{{ errors.first('userForm.ROLE') }}</span>
                </div>
                <div v-else class="col-md-12 error_height">
                  <label>User Type</label>
                  <select class="form-control input-group" v-validate="'required'" name="ROLE" v-model="ROLE">
                    <option v-for="user in userRoles" v-bind:value="user.value">
                      {{ user.name }}
                    </option>
                  </select>
                  <span v-show="errors.has('userForm.ROLE')" class="text-danger">{{ errors.first('userForm.ROLE') }}</span>
                </div>
                <div class="col-md-12">
                  <label>Select Restaurant(s) This User Will Have Access To</label></br>
                  <input type="checkbox" for="select_all" v-model="selectAll">
                  <label for="select_all">Select All</label>
                </div>
                <div class="col-md-12 restaurants_wrapper">
                  <div v-for="rest in restaurants" class="col-md-6">
                    <input type="checkbox" v-bind:value="rest.externalId" v-bind:id="rest.externalId" v-model="checkedRestaurants">
                    <label class="checkbox_label" v-bind:for="rest.externalId">{{rest.entityName}}<span v-if="rest.entityStoreNumber"> - {{rest.entityStoreNumber}}</span> - <span class="address_small">{{rest.entityAddress.address}}</span></label>
                  </div>
                </div>
                <input type="hidden" name="UID" v-model="UID">
              </div>
            </slot>
          </section>
        </form>
        <footer class="modal-footer">
          <slot name="footer">
            <button type="submit" class="btn btn-primary btn-fill btn-wd" @click="addUpdateUser">{{modalButtonText}}</button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
import {API} from 'src/api'
import PortalNotification from 'src/components/UIComponents/NotificationPlugin/Notification.vue'
import { mixin as clickaway } from 'vue-clickaway'
var support = ''
var userRoles = ''
if(localStorage.userInfo) {
  var userInfo = JSON.parse(localStorage.userInfo)
  if(userInfo.company == 'Support') {
    support = true
  } else {
    support = false
  }
  if(userInfo.role == 14 || support) {
    userRoles = [{ name: '-Select-', value: '' }, { name: 'Corporate', value: '14' }, { name: 'Regional', value: '15' }, { name: 'Local', value: '16' }]
  } else if (userInfo.role == 15) {
    userRoles = [{ name: '-Select-', value: '' }, { name: 'Regional', value: '15' }, { name: 'Local', value: '16' }]
  }
}
export default {
  data () {
    return {
      FNAME: '',
      LNAME: '',
      EMAIL: '',
      PHONE: '',
      ROLE: '',
      PASSWORD: '',
      COMPANY: '',
      UID: '',
      modalHeading: 'Add New User',
      modalButtonText: 'Create User & Send Invitation',
      userRoles: userRoles,
      support: support,
      restaurants: [],
      checkedRestaurants: [],
      nationalPartners: [],
      np_selected: [],
      isActive: true
    }
  },
  mixins: [ clickaway ],
  components: {
    PortalNotification
  },
  methods: {
    close () {
      this.$emit('close')
      this.np_selected = []
    },
    away: function() {
      this.close()
    },
    addUpdateUser (scope) {
      console.log('checkedRestaurants', this.checkedRestaurants)
      var self = this
      var company = []
      if(userInfo.company == 'Support') {
        for (let np_sel of Object.values(this.np_selected)) {
          company.push(np_sel.CODE)
        }
      } else {
        company = userInfo.company
      }
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          var userInfo = JSON.parse(localStorage.userInfo)
          if(this.UID) {
            API.put('/profile/' + encodeURIComponent(this.EMAIL), {
              fname: this.FNAME,
              lname: this.LNAME,
              email: this.EMAIL,
              phone: this.PHONE,
              role: this.ROLE,
              password: this.PASSWORD,
              company: company,
              restaurants: this.checkedRestaurants,
              //createdby: userInfo.uid,
              npuser: true
            })
            .then(function (response) {
              // console.log(JSON.stringify(response, null, '  '))
              if (response.data.uid) {
                self.close()
                self.notifyVue('top', 'center', 'The user has been updated successfully!', 'ti-check-box', 'success')
                // event.target.reset()
                // Object.assign(this.$data, this.$options.data.call(this))
              }
            })
            .catch(function (error) {
              console.log(error)
              self.notifyVue('top', 'center', 'There was a problem updating the user', 'ti-alert', 'danger')
            })
          } else {
            API.post('/profile', {
              FNAME: this.FNAME,
              LNAME: this.LNAME,
              EMAIL: this.EMAIL,
              PHONE: this.PHONE,
              // PASSWORD: this.PASSWORD,
              ROLE: this.ROLE,
              COMPANY: company,
              RESTAURANTS: this.checkedRestaurants,
              CREATEDBY: userInfo.uid,
              npuser: true
            })
            .then(function (response) {
              // console.log(JSON.stringify(response, null, '  '))
              if (response.data.uid) {
                self.close()
                self.notifyVue('top', 'center', 'The new user has been created successfully!', 'ti-check-box', 'success')
                // event.target.reset()
              } else {
                self.close()
                self.notifyVue('top', 'center', 'The email already exists', 'ti-check-box', 'danger')
              }
            })
            .catch(function (error) {
              // console.log(error)
              self.notifyVue('top', 'center', 'There was a problem creating the new user', 'ti-alert', 'danger')
            })
          }
        }
      })
    },
    notifyVue (verticalAlign, horizontalAlign, message, icon, type) {
      this.$notifications.notify(
        {
          message: message,
          icon: icon,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: type
        })
    },
    getRestaurants (profile) {
      var self = this
      var company = []
      if(userInfo.company == 'Support') {
        for (let np_sel of Object.values(this.np_selected)) {
          company.push(np_sel.CODE)
        }
      } else {
        company = userInfo.company
      }
      if(profile) {
        company = []
        for (let np_sel of profile.company.split(',')) {
          company.push(np_sel)
        }
      }
      //console.log('comapny ' + company)
      self.restaurants = []
      //API.get('/restaurant/NP?np=' + company + '&role=' + userInfo.role + '&uid=' + userInfo.uid)
      API.get('/restaurant/NP?np=' + company + '&role=' + profile.role + '&uid=' + profile.uid)
      .then(function (response) {
        if(response.data.entities) {
          for (let rest of Object.values(response.data.entities)) {
            self.restaurants.push(rest)
          }
        }
        console.log('restaurants', self.restaurants)
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    getNationalPartners () {
      var self = this
      API.get('/report/partners?np=' + userInfo.company)
      .then(function (response) {
        for (let np of Object.values(response.data.rv)) {
          self.nationalPartners.push(np)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    clearAllNP () {
      this.np_selected = []
    }
  },
  computed: {
    selectAll: {
      get: function () {
        return this.restaurants ? this.checkedRestaurants.length == this.restaurants.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.restaurants.forEach(function (rest) {
            selected.push(rest.externalId);
          });
        }
        this.checkedRestaurants = selected;
      }
    }
  },
  mounted () {
    if(userInfo.company != 'Support') {
      this.getRestaurants()
    }
    this.getNationalPartners()
  },
}
</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .3s ease;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 900px;
    transition: opacity .3s ease;
    /* overflow: scroll !important; */
    margin: 0 auto;
    top: 30px !important;
    bottom: 50px !important;
  }

  .modal-header,
  .modal-footer {
    padding: 0 15px;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    font-weight: 600;
    color: #333;
    font-size: 22px;
  }

  .modal-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
  }

  .modal-body {
    max-height: calc(100vh - 150px - 60px);
    max-height: -moz-calc(100vh - 150px - 60px);
    max-height: -webkit-calc(100vh - 150px - 60px);
    width: 100%;
    overflow-y: auto !important;
  }

  .btn-close {
    border: none;
    font-size: 20px;
    font-weight: bold;
  }

  .border-danger {
    border-color: red !important;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  */

  .modal-enter-active,
  .modal-leave-active {
    transition: opacity .8s;
  }

  .modal-enter-to,
  .modal-leave {
    transform: translateX(50);
  }

  .modal-enter,
  .modal-leave-to,
  /* .modal-leave-active in <2.1.8 */ {
  opacity: 0;
  }

  .address_small {
    font-size: 12px;
    font-weight: 400;
  }
  .checkbox_label {
    font-size: 12px;
  }
  #userForm .error_height {
    min-height: 100px;
  }

  #userForm .error_height .input-group {
    margin-bottom: 0;
  }

  .modal .modal-footer .btn-wd {
    margin: 0;
  }

  /* .restaurants_wrapper {
    overflow: scroll;
  } */

  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */

</style>



// WEBPACK FOOTER //
// UserModal.vue?8e18ce40